
import { Avatar, Button, IconButton, Popover, Typography, Menu, MenuItem, Badge as MuiBadge } from "@mui/material";
import { Box } from "@mui/system";
import logo from "../Assets/SmartKart_Logo_Final_SmartKart_Color.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from 'primereact/badge';
import { updateOrderDetails, updateOrderModel, updateselectedDeliveryPartner } from "../Redux/orders";
import { Dropdown } from "primereact/dropdown";
import { useGetInventory, useGetCampaign, useGetOffers, useFetchOrders, useGetProducts } from "./globalFunctions";
import { updateSelectedHub } from "../Redux/user";
import { updateInventory } from "../Redux/inventory";
import CustomAxios from "../utils/CustomAxios";
import dayjs from "dayjs";
import {useGetProductBanners} from '../Components/globalFunctions'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import MenuIcon from "@mui/icons-material/Menu";
import getBrand from "../brands/getBrand";
import { clearAppConfigCache, prefetchAppConfig, getCurrentHubId, getAppConfigSync } from "../utils/getAppConfig";
import { updatePWAConfig } from "../utils/updatePWAConfig";
import { cacheAppConfigForSW } from "../utils/cacheAppConfigForSW";
export function Header() {
    const first_name = useSelector(state => state.user.first_name);
    const last_name = useSelector(state => state.user.last_name);
    const dispatch = useDispatch();
    const pending = useSelector(state => state.orders.pendingOrders);
    const socketStatus = useSelector(state => state.page.socketStatus);
    const inventory = useSelector(state => state.inventory.inventory);
    const hub = useSelector(state => state.user.selected_hub);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [anchorElNotify, setAnchorElNotify] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [appConfigVersion, setAppConfigVersion] = useState(0); // Force re-render when AppConfig loads
    const orderDate = useSelector(state => state.orders.selectedDate)
    const user_role = localStorage.getItem('role');
    const userCart = useSelector(state => state.user.userCart || []);
    const user_name = localStorage.getItem('first_name');
    const today = dayjs()
    const navigate = useNavigate();
    const getCampaign = useGetCampaign()
    const getInventory = useGetInventory();
    const getOffers = useGetOffers()
    const GetOrders = useFetchOrders()
    const getDetails = useGetProducts()
    const getProductBanner = useGetProductBanners()


    const handleClick = (event) => setAnchorElNotify(event.currentTarget);
    const handleCloseNotify = () => setAnchorElNotify(null);

    const capitalize = (str) => str?.split(' ').map(word => word?.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    const getRoleColors = (role) => {
        switch (role) {
            case 'super_admin':
                return {
                    bg: 'rgba(220, 38, 127, 0.1)', 
                    border: 'rgba(220, 38, 127, 0.2)',
                    nameColor: '#DC267F',
                    roleColor: '#BE185D' 
                };
            case 'admin':
                return {
                    bg: 'rgba(59, 130, 246, 0.1)', 
                    border: 'rgba(59, 130, 246, 0.2)', 
                    nameColor: '#3B82F6', 
                    roleColor: '#1D4ED8'
                };
            case 'supervisor':
                return {
                    bg: 'rgba(16, 185, 129, 0.1)', 
                    border: 'rgba(16, 185, 129, 0.2)', 
                    nameColor: '#10B981', 
                    roleColor: '#059669'
                };
            case 'customer_engagement_admin':
                return {
                    bg: 'rgba(245, 158, 11, 0.1)', 
                    border: 'rgba(245, 158, 11, 0.2)', 
                    nameColor: '#F59E0B', 
                    roleColor: '#D97706' 
                };
            default:
                return {
                    bg: 'rgba(107, 114, 128, 0.1)', 
                    border: 'rgba(107, 114, 128, 0.2)', 
                    nameColor: '#6B7280', 
                    roleColor: '#4B5563' 
                };
        }
    };

    const roleColors = getRoleColors(user_role);

    const totalCartItems = useMemo(() => {
        if (!Array.isArray(userCart)) return 0;
        return userCart.reduce((acc, item) => {
            if (Array.isArray(item.capacity)) {
                const qty = item.capacity.reduce((sum, cap) => sum + Number(cap.item_quantity || 0), 0);
                return acc + qty;
            }
            return acc;
        }, 0);
    }, [userCart]);

    const getHubName = (hubId) => {
        const matched = inventory?.find((inv) => inv.value === hubId);
        return matched ? matched.name : null;
    };

    const [selectedHub, setSelectedHub] = useState(null);

    // const handleChange = (e) => {
    //     const selectedHub = e.value;
    //     dispatch(updateSelectedHub([selectedHub]));
    //     localStorage.setItem('selected_hub', selectedHub);
    // };
    const handleChange = async (e) => {
        const selectedHub = e.value;
        
        // Get old hub ID before updating
        const oldHubId = getCurrentHubId();
        
        setSelectedHub(selectedHub); // <-- important
        dispatch(updateSelectedHub([selectedHub]));
        localStorage.setItem('selected_hub', selectedHub);
        
        // Store franchise ID for the selected hub
        const selectedInventory = inventory.find(inv => inv.value === selectedHub);
        
        if (selectedInventory && selectedInventory.franchise) {
            const franchiseId = selectedInventory.franchise.id || selectedInventory.franchise;
            localStorage.setItem('selected_franchise_id', franchiseId.toString());
        } else {
            localStorage.removeItem('selected_franchise_id');
        }

        // Clear old AppConfig cache and update PWA config for new hub
        try {
            // Clear cache for old hub
            if (oldHubId && oldHubId !== selectedHub) {
                clearAppConfigCache(oldHubId);
            }
            
            // Prefetch AppConfig for new hub
            await prefetchAppConfig(selectedHub);
            
            // Update service worker cache
            await cacheAppConfigForSW();
            
            // Update PWA config (favicon, title, etc.)
            await updatePWAConfig(false);
        } catch (error) {
            // Still try to update even if prefetch fails
            await updatePWAConfig(false);
        }
    };

    useEffect(() => {
        dispatch(updateSelectedHub([selectedHub]));
    }, [selectedHub])

    useEffect(() => {
        if (inventory && inventory.length > 0 && selectedHub) {
            const hubExists = inventory.some(inv => inv.value === selectedHub);
            if (!hubExists) {
                const firstHub = inventory[0];
                const oldHubId = getCurrentHubId();
                
                setSelectedHub(firstHub.value);
                localStorage.setItem('selected_hub', firstHub.value.toString());
                dispatch(updateSelectedHub([firstHub.value]));
                
                // Store franchise ID for the automatically selected hub
                if (firstHub.franchise) {
                    const franchiseId = firstHub.franchise.id || firstHub.franchise;
                    localStorage.setItem('selected_franchise_id', franchiseId.toString());
                }

                // Update PWA config for auto-selected hub
                (async () => {
                    try {
                        if (oldHubId && oldHubId !== firstHub.value) {
                            clearAppConfigCache(oldHubId);
                        }
                        await prefetchAppConfig(firstHub.value);
                        await cacheAppConfigForSW();
                        updatePWAConfig();
                    } catch (error) {
                        updatePWAConfig();
                    }
                })();
            }
        }
    }, [inventory, selectedHub]);

    // Effect to store franchise ID when inventory data is loaded and hub is already selected
    useEffect(() => {
        if (inventory && inventory.length > 0 && selectedHub) {
            const selectedInventory = inventory.find(inv => inv.value === selectedHub);
            
            if (selectedInventory && selectedInventory.franchise) {
                const franchiseId = selectedInventory.franchise.id || selectedInventory.franchise;
                localStorage.setItem('selected_franchise_id', franchiseId.toString());
            } else {
                localStorage.removeItem('selected_franchise_id');
            }
        }
    }, [inventory]); // Run when inventory data is loaded


    // const total_hub = JSON.parse(localStorage.getItem('hub'));

    useEffect(() => {
        try {
            const total_hub = JSON.parse(localStorage.getItem('hub') || '[]');
            const user_role = localStorage.getItem('role');
            const currentSelectedHubRaw = localStorage.getItem('selected_hub');
            let currentSelectedNumeric = null;
            try {
                const parsedSel = JSON.parse(currentSelectedHubRaw || 'null');
                currentSelectedNumeric = Array.isArray(parsedSel) ? (parsedSel[0] ?? null) : (parsedSel ?? null);
            } catch (e) {
                currentSelectedNumeric = currentSelectedHubRaw ? Number(currentSelectedHubRaw) : null;
            }

            let nextFiltered = [];
            if (user_role === 'super_admin') {
                nextFiltered = inventory;
            } else if (['supervisor', 'admin', 'customer_engagement_admin'].includes(user_role)) {
                if (Array.isArray(total_hub) && total_hub.length > 0) {
                    nextFiltered = inventory.filter(item => total_hub.includes(item.value));
                } else if (currentSelectedNumeric) {
                    // No assigned hubs array → restrict to currently selected hub only
                    nextFiltered = inventory.filter(item => item.value === Number(currentSelectedNumeric));
                } else {
                    nextFiltered = [];
                }
            } else if (user_role === 'merchant') {
                // For merchant role, show inventory based on their linked inventory_id
                if (Array.isArray(total_hub) && total_hub.length > 0) {
                    // Filter inventory by total_hub array
                    nextFiltered = inventory.filter(item => total_hub.includes(item.value));
                    
                    // If filtered list is empty but we have a selected hub, try to find it in the full inventory
                    if (nextFiltered.length === 0 && currentSelectedNumeric) {
                        const selectedInventory = inventory.find(inv => inv.value === Number(currentSelectedNumeric));
                        if (selectedInventory) {
                            nextFiltered = [selectedInventory];
                        } else {
                            // Inventory not in list yet - create a placeholder entry so dropdown shows
                            nextFiltered = [{
                                name: `Hub ${currentSelectedNumeric}`,
                                value: Number(currentSelectedNumeric),
                                place: `Hub ${currentSelectedNumeric}`,
                                id: Number(currentSelectedNumeric)
                            }];
                        }
                    }
                    
                    // Also check if any hub from total_hub exists in inventory
                    total_hub.forEach(hubId => {
                        const hubInInventory = inventory.find(inv => inv.value === Number(hubId));
                        if (hubInInventory && !nextFiltered.some(inv => inv.value === hubInInventory.value)) {
                            nextFiltered.push(hubInInventory);
                        }
                    });
                } else if (currentSelectedNumeric) {
                    // If inventory_id is set from OTP verification, show that inventory
                    nextFiltered = inventory.filter(item => item.value === Number(currentSelectedNumeric));
                    
                    // If not found in inventory list, create a placeholder
                    if (nextFiltered.length === 0) {
                        nextFiltered = [{
                            name: `Hub ${currentSelectedNumeric}`,
                            value: Number(currentSelectedNumeric),
                            place: `Hub ${currentSelectedNumeric}`,
                            id: Number(currentSelectedNumeric)
                        }];
                    }
                } else {
                    nextFiltered = [];
                }
            } else {
                nextFiltered = inventory.filter(item => total_hub.includes(item.value));
            }

            setFilteredInventory(nextFiltered);

            if (nextFiltered.length > 0) {
                const currentSelectedHub = localStorage.getItem('selected_hub');
                if (!currentSelectedHub || currentSelectedHub === '[]' || currentSelectedHub === '') {
                    const firstHub = nextFiltered[0];
                    localStorage.setItem('selected_hub', firstHub.value.toString());
                    dispatch(updateSelectedHub([firstHub.value]));
                    setSelectedHub(firstHub.value);
                } else {
                    try {
                        const parsedHub = JSON.parse(currentSelectedHub);
                        const selectedValue = Array.isArray(parsedHub) && parsedHub.length > 0 ? parsedHub[0] : Number(currentSelectedHub);
                        const existsInFiltered = nextFiltered.some(inv => inv.value === Number(selectedValue));
                        if (existsInFiltered) {
                            setSelectedHub(Number(selectedValue));
                        } else {
                            const firstHub = nextFiltered[0];
                            localStorage.setItem('selected_hub', firstHub.value.toString());
                            dispatch(updateSelectedHub([firstHub.value]));
                            setSelectedHub(firstHub.value);
                        }
                    } catch (error) {
                        const selectedValue = Number(currentSelectedHub);
                        const existsInFiltered = nextFiltered.some(inv => inv.value === selectedValue);
                        setSelectedHub(existsInFiltered ? selectedValue : nextFiltered[0].value);
                        if (!existsInFiltered) {
                            localStorage.setItem('selected_hub', nextFiltered[0].value.toString());
                            dispatch(updateSelectedHub([nextFiltered[0].value]));
                        }
                    }
                }
            } else {
                // For merchant, if we have a selected hub but inventory list is empty, keep the selected hub value
                if (user_role === 'merchant' && currentSelectedNumeric) {
                    setSelectedHub(currentSelectedNumeric);
                } else {
                    setSelectedHub(null);
                }
            }
        } catch (error) {
            setFilteredInventory([]);
        }
    }, [inventory]);

    useEffect(() => {
        getInventory();

        const storedHub = localStorage.getItem('hub');
        const selectedHubFromStorage = localStorage.getItem('selected_hub');
        const user_role = localStorage.getItem('role');

        let parsedHub = [];

        if (storedHub) {
            try {
                parsedHub = JSON.parse(storedHub);
            } catch (error) {
                // Fallback for old format
                parsedHub = storedHub.includes(',')
                    ? storedHub.split(',').map(Number)
                    : [Number(storedHub)];
            }
        }

        if (parsedHub.length > 0) {
            dispatch(updateSelectedHub(parsedHub));
        }

        if (selectedHubFromStorage) {
            try {
                const parsedSelectedHub = JSON.parse(selectedHubFromStorage);
                if (Array.isArray(parsedSelectedHub) && parsedSelectedHub.length > 0) {
                    setSelectedHub(parsedSelectedHub[0]);
                    dispatch(updateSelectedHub(parsedSelectedHub));
                } else {
                    setSelectedHub(Number(selectedHubFromStorage));
                    dispatch(updateSelectedHub([Number(selectedHubFromStorage)]));
                }
            } catch (error) {
                const hubValue = Number(selectedHubFromStorage);
                setSelectedHub(hubValue);
                dispatch(updateSelectedHub([hubValue]));
            }
        }
    }, []);

    // For merchant role, fetch specific inventory if it's not in the list
    useEffect(() => {
        const fetchMerchantInventory = async () => {
            if (user_role === 'merchant') {
                const storedHub = localStorage.getItem('hub');
                const selectedHubFromStorage = localStorage.getItem('selected_hub');
                let hubId = null;
                
                if (storedHub) {
                    try {
                        const parsed = JSON.parse(storedHub);
                        hubId = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : parsed;
                    } catch (e) {
                        hubId = Number(storedHub);
                    }
                } else if (selectedHubFromStorage) {
                    try {
                        const parsed = JSON.parse(selectedHubFromStorage);
                        hubId = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : parsed;
                    } catch (e) {
                        hubId = Number(selectedHubFromStorage);
                    }
                }
                
                if (hubId && inventory && inventory.length > 0) {
                    const hubExists = inventory.some(inv => inv.value === Number(hubId));
                    if (!hubExists) {
                        try {
                            // Fetch the specific inventory details
                            const response = await CustomAxios.get(`inventory/view`);
                            const hubList = response?.data || [];
                            const merchantHub = hubList.find(hub => hub.id === Number(hubId));
                            
                            if (merchantHub) {
                                // Add the merchant hub to the inventory list
                                const hubOption = {
                                    name: merchantHub.place,
                                    value: merchantHub.id,
                                    supervisors: merchantHub.supervisors || [],
                                    admins: merchantHub.admins || [],
                                    customer_engagement_admins: merchantHub.customer_engagement_admins || [],
                                    cashier_ids: merchantHub.cashier_ids || [],
                                    pincodes: merchantHub.pincodes || [],
                                    franchise: merchantHub.franchise,
                                    delivery_fee: merchantHub.delivery_fee,
                                    self_pickup_waiver: merchantHub.self_pickup_waiver,
                                    self_pickup_waiver_percentage: merchantHub.self_pickup_waiver_percentage,
                                    mobileno: merchantHub.mobileno,
                                    delivery_status: merchantHub.delivery_status,
                                    delivery_mini_spent: merchantHub.delivery_mini_spent,
                                    shop_open_at: merchantHub.shop_open_at,
                                    shop_close_at: merchantHub.shop_close_at,
                                    hub_setup: merchantHub.hub_setup,
                                    hub_link: merchantHub.hub_link || ''
                                };
                                
                                // Update inventory list with the merchant hub
                                const updatedInventory = [...inventory, hubOption];
                                dispatch(updateInventory(updatedInventory));
                            }
                        } catch (error) {
                            // Error fetching merchant hub details
                        }
                    }
                }
            }
        };
        
        // Only fetch if inventory is loaded but merchant hub is missing
        if (user_role === 'merchant' && inventory && inventory.length > 0) {
            fetchMerchantInventory();
        }
    }, [inventory, user_role]);


    function stringToColor(string) {
        let hash = 0;
        for (let i = 0; i < string.length; i++) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        return color;
    }

    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }

    const brand = getBrand();
    const logout = () => {
        localStorage.clear();
        navigate("/");
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleModalChange = (item) => {
        handleCloseNotify();
        dispatch(updateOrderModel(true));
        dispatch(updateOrderDetails(item));
        if (item.delivery_partner_id) {
            dispatch(updateselectedDeliveryPartner(item.delivery_partner_id));
        } else {
            dispatch(updateselectedDeliveryPartner(""));
        }
    };



    useEffect(() => {
        getInventory();
        getCampaign()
        getOffers()
        getDetails()
        getProductBanner()
        orderDate != null && GetOrders(orderDate[0], orderDate[1])
    }, [hub]);

    // Watch for AppConfig changes and force re-render
    useEffect(() => {
        const checkAppConfig = () => {
            const appConfig = getAppConfigSync();
            if (appConfig) {
                setAppConfigVersion(prev => prev + 1);
            }
        };

        // Check immediately
        checkAppConfig();

        // Check periodically until AppConfig is loaded
        const interval = setInterval(() => {
            checkAppConfig();
        }, 500);

        // Clear interval after 10 seconds (AppConfig should be loaded by then)
        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 10000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [hub]); // Re-check when hub changes

    return (
        <Box sx={{ 
            width: "100%", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center", 
            backgroundColor: "background.light",
            flexWrap: { xs: "wrap", md: "nowrap" },
            minHeight: { xs: "auto", md: "72px" }
        }}>
            <Box sx={{ 
                display: "flex", 
                gap: { xs: "8px", md: "12px" }, 
                alignItems: "center", 
                padding: { xs: "8px 12px", md: "20px" },
                flexShrink: 0
            }}>
                {user_role === 'user' && (
                    <IconButton
                        onClick={() => {
                            if (typeof window !== "undefined") {
                                window.dispatchEvent(new CustomEvent("toggle-category-menu"));
                            }
                        }}
                        sx={{
                            border: "1px solid #dfe1e5",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            color: brand?.themeColor || "#1976d2",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            width: { xs: 36, md: 40 },
                            height: { xs: 36, md: 40 },
                            mr: { xs: 0, md: 2 }
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <Box 
                    component="img" 
                    key={`app-icon-${appConfigVersion}-${brand.appIcon}`}
                    sx={{ width: { xs: "28px", md: "38px" }, height: { xs: "24px", md: "32px" } }} 
                    src={brand.appIcon || logo} 
                    alt={brand.appShortName || "Logo"}
                    onError={(e) => {
                        // Fallback to default logo if custom icon fails to load
                        if (e.target.src !== logo) {
                            e.target.src = logo;
                        }
                    }}
                />
                <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "4px", md: "8px" } }}>
                    <Typography sx={{ 
                        lineHeight: { xs: "8px", md: "10px" }, 
                        fontSize: { xs: "12px", md: "18px" }, 
                        fontWeight: "600" 
                    }}>
                        {brand.appShortName }
                    </Typography>
                    
                </Box>
            </Box>
            <Box sx={{ 
                width: {  md: "100%" }, 
                maxWidth: { xs: "100%", md: "400px" }, 
                display: "flex", 
                justifyContent: { xs: "space-between", md: "flex-end" }, 
                gap: { xs: "8px", md: "14px" }, 
                alignItems: "center", 
                padding: { xs: "8px 12px", md: "20px" },
                paddingRight: { xs: "12px", md: "20px" },
                flexWrap: { xs: "wrap", md: "nowrap" }
            }}>
                {user_role !== 'user' && user_role !== 'merchant' && (
                    <>
                        {/* Select the hub dropdown */}
                        {user_role === 'super_admin' && filteredInventory && filteredInventory.length > 0 ? (
                            <Box sx={{ 
                                width: { xs: "140px", sm: "180px", md: "240px" },
                                "& .p-dropdown": {
                                    height: { xs: "28px", md: "32px" },
                                    fontSize: { xs: "12px", md: "14px" }
                                }
                            }}>
                                <Dropdown
                                    onChange={handleChange}
                                    value={selectedHub}
                                    options={filteredInventory}
                                    name="details_id"
                                    optionLabel="name"
                                    style={{ zIndex: "1000", height: "32px", width: "240px" }}
                                    placeholder="Select the hub"
                                    className="w-full md:w-14rem"
                                    checkmark
                                    highlightOnSelect={false}
                                />
                            </Box>
                        ) : null}
                        {/* User Info Label (Merchant Box) */}
                        <Box sx={{ 
                            display: { xs: "none", md: "flex" }, 
                            flexDirection: "column", 
                            alignItems: "center",
                            padding: "4px 12px",
                            backgroundColor: roleColors.bg,
                            borderRadius: "8px",
                            border: `1px solid ${roleColors.border}`,
                            minWidth: "120px"
                        }}>
                            <Typography sx={{ 
                                fontSize: "12px", 
                                fontWeight: "600", 
                                color: roleColors.nameColor,
                                lineHeight: "14px"
                            }}>
                                {user_name || 'User'}
                            </Typography>
                            <Typography sx={{ 
                                fontSize: "10px", 
                                fontWeight: "500", 
                                color: roleColors.roleColor,
                                lineHeight: "12px",
                                textTransform: "capitalize"
                            }}>
                                {user_role?.replace('_', ' ') || 'Role'}
                            </Typography>
                        </Box>
                

                <IconButton 
                    disabled={pending.length > 0 ? false : true} 
                    aria-describedby="simple-popover" 
                    onClick={handleClick}
                    sx={{ 
                        padding: { xs: "4px", md: "8px" },
                        "& .pi": { 
                            fontSize: { xs: "16px", md: "20px" } 
                        }
                    }}
                >
                    <i className="pi pi-bell p-overlay-badge">
                        {pending.length > 0 && <Badge value={pending.length} />}
                    </i>
                </IconButton>
                {/* Mobile User Info Label */}
                <Box sx={{ 
                    display: { xs: "flex", md: "none" }, 
                    flexDirection: "column", 
                    alignItems: "center",
                    padding: "2px 8px",
                    backgroundColor: roleColors.bg,
                    borderRadius: "6px",
                    border: `1px solid ${roleColors.border}`,
                    minWidth: "80px"
                }}>
                    <Typography sx={{ 
                        fontSize: "10px", 
                        fontWeight: "600", 
                        color: roleColors.nameColor,
                        lineHeight: "12px"
                    }}>
                        {user_name || 'User'}
                    </Typography>
                    <Typography sx={{ 
                        fontSize: "8px", 
                        fontWeight: "500", 
                        color: roleColors.roleColor,
                        lineHeight: "10px",
                        textTransform: "capitalize"
                    }}>
                        {user_role?.replace('_', ' ') || 'Role'}
                    </Typography>
                </Box>
                    </>
                )}
                <Box sx={{ 
                    width: "auto", 
                    maxWidth: "none", 
                    display: "flex", 
                    justifyContent: "flex-end", 
                    gap: "12px", 
                    alignItems: "center",
                    flexShrink: 0
                }}>
                    {user_role === 'user' && (
                        <IconButton
                            onClick={() => navigate("/cart")}
                            sx={{
                                padding: { xs: "4px", md: "6px" },
                                border: "1px solid #dfe1e5",
                                borderRadius: "12px",
                                backgroundColor: "#fff",
                                color: brand?.themeColor || "#1976d2",
                                "&:hover": { backgroundColor: "#f5f5f5" }
                            }}
                        >
                            <MuiBadge color="primary" badgeContent={totalCartItems || 0} overlap="circular">
                                <ShoppingCartOutlinedIcon />
                            </MuiBadge>
                        </IconButton>
                    )}
                    <Avatar 
                        onClick={(event) => user_role == 'user' ? navigate('/user_profile'): setAnchorEl(event.currentTarget)}
                        sx={{ 
                            height: { xs: "28px", md: "32px" }, 
                            width: { xs: "28px", md: "32px" }, 
                            borderRadius: "50%", 
                            bgcolor: "#3B82F6", 
                            fontSize: { xs: "12px", md: "14px" }, 
                            fontWeight: "700", 
                            cursor: "pointer"
                        }}
                    >
                        <PersonOutlineOutlinedIcon sx={{ fontSize: { xs: "16px", md: "20px" } }} />
                    </Avatar>
                    {/* <Avatar {...stringAvatar(capitalize(first_name) + " " + capitalize(last_name))} onClick={(event) => setAnchorEl(event.currentTarget)} style={{ height: "32px", width: "32px", borderRadius: "16px", bgcolor: "#3B82F6", fontSize: "14px", fontWeight: "700", cursor: "pointer" }} /> */}
                </Box>
            </Box>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{ padding: 0 }}
            >
                <MenuItem sx={{ backgroundColor: 'white', padding: "5px 15px" }} disabled={true} >{user_name} - {user_role}</MenuItem>
                <MenuItem sx={{ backgroundColor: 'white', padding: "5px 15px" }} onClick={() => logout()}>Logout</MenuItem>
            </Menu>
            <Popover 
                id="simple-popover" 
                open={Boolean(anchorElNotify)} 
                anchorEl={anchorElNotify} 
                onClose={handleCloseNotify} 
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                sx={{ 
                    maxWidth: { xs: "90vw", md: "400px" },
                    width: { xs: "90vw", md: "400px" }
                }}
            >                
            {pending?.length > 0 && pending?.map((item) => (
                   <Box sx={{ 
                    width: { xs: "90vw", md: "400px" }, 
                    maxWidth: { xs: "90vw", md: "400px" },
                    height: "100%", 
                    minHeight: "100px", 
                    backgroundColor: 'white', 
                    border: "1px", 
                    borderColor: "secondary.border", 
                    padding: { xs: "8px", md: "10px" }
                }}>
                    <Box sx={{ padding: { xs: "8px", md: "10px" }, backgroundColor: "background.default", borderRadius: "5px" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: { xs: "12px", md: "14px" } }}>Order Id: {item.order_id}</Typography>
                        <Box sx={{ display: "flex", gap: { xs: "6px", md: "10px" }, justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "flex-start", sm: "center" }, mt: { xs: "8px", md: "4px" } }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography sx={{ fontSize: { xs: "12px", md: "14px" }, fontWeight: "400", lineHeight: { xs: "18px", md: "22px" } }}>
                                    {item?.delivery_address?.door_flat_no}, {item?.delivery_address?.address}
                                </Typography>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    sx={{ 
                                        height: { xs: "28px", md: "32px" },
                                        fontSize: { xs: "11px", md: "14px" },
                                        minWidth: { xs: "60px", md: "auto" }
                                    }} 
                                    onClick={() => handleModalChange(item)}
                                >
                                    View
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Popover>
        </Box>
    );
}
